import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=32e12d0e"
import script from "./Slider.ts?vue&type=script&lang=ts&external"
export * from "./Slider.ts?vue&type=script&lang=ts&external"
import style0 from "./Slider.vue?vue&type=style&index=0&id=32e12d0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports